import { render } from "./alba.vue?vue&type=template&id=d8838950&ts=true"
import script from "./alba.vue?vue&type=script&lang=ts"
export * from "./alba.vue?vue&type=script&lang=ts"

import "./alba.vue?vue&type=style&index=0&id=d8838950&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__